// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__AlJtb","list":"PatternAutocomplete_list__9WGbu"};